import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from './ui.actions';

export interface UiState {
  sidebarManuallyOpen: boolean;
}

export const initialUiState: UiState = {
  sidebarManuallyOpen: false,
};

const reducer = createReducer(
  initialUiState,
  on(
    fromActions.toggleSidebar,
    state =>
      (state = {
        ...state,
        sidebarManuallyOpen: !state.sidebarManuallyOpen,
      }),
  ),
  on(
    fromActions.closeSidebar,
    state =>
      (state = {
        ...state,
        sidebarManuallyOpen: false,
      }),
  ),
  on(
    fromActions.openSidebar,
    state =>
      (state = {
        ...state,
        sidebarManuallyOpen: true,
      }),
  ),
);

export function uiReducer(state: UiState, action: Action) {
  return reducer(state, action);
}
